import React, { useState, useEffect } from 'react';
import { Smartphone, Plus, Trash2, Loader2, Facebook, Instagram } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const fmt = (p) => p.replace(/^\+1(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');

export const PhotoSendersPanel = () => {
  const [data, setData] = useState(null);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => axios.get(`${API}/admin/photo-senders`, { headers: auth() }).then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.post(`${API}/admin/photo-senders`, { name, phone }, { headers: auth() });
      setName(''); setPhone('');
      toast.success('Numéro autorisé');
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Échec');
    }
    setSaving(false);
  };

  const remove = async (s) => {
    if (!window.confirm(`Retirer ${s.name || fmt(s.phone)}?`)) return;
    await axios.delete(`${API}/admin/photo-senders/${s.id}`, { headers: auth() });
    toast.success('Numéro retiré');
    load();
  };

  if (!data) return <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-blue-500" /></div>;

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5 space-y-4" data-testid="photo-senders-panel">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="font-semibold text-slate-900 flex items-center gap-2"><Smartphone className="h-4 w-4 text-blue-600" /> Envoi de photos par texto</h2>
          <p className="text-sm text-slate-500">Ces numéros peuvent texter une photo au <strong>438-807-8182</strong> pour la publier. Répondre SUPPRIMER retire la dernière.</p>
        </div>
        <div className="flex flex-wrap gap-1.5">
          <span className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full ${data.facebook_connected ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`} data-testid="facebook-status">
            <Facebook className="h-3.5 w-3.5" /> {data.facebook_connected ? 'Facebook actif' : 'Facebook non connecté'}
          </span>
          <span className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full ${data.instagram_connected ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`} data-testid="instagram-status">
            <Instagram className="h-3.5 w-3.5" /> {data.instagram_connected ? 'Instagram actif' : 'Instagram non connecté'}
          </span>
        </div>
      </div>
      <ul className="divide-y divide-slate-100" data-testid="photo-senders-list">
        {data.admin_phone && (
          <li className="flex items-center justify-between py-2" data-testid="photo-sender-admin">
            <span className="text-sm text-slate-800"><span className="font-medium">Admin</span> <span className="text-slate-500 ml-2">{fmt(data.admin_phone)}</span></span>
            <span className="text-xs text-slate-400">Toujours autorisé</span>
          </li>
        )}
        {data.senders.length === 0 && !data.admin_phone && <li className="py-2 text-sm text-slate-500" data-testid="photo-senders-empty">Aucun numéro autorisé.</li>}
        {data.senders.map((s) => (
          <li key={s.id} className="flex items-center justify-between py-2" data-testid={`photo-sender-${s.id}`}>
            <span className="text-sm text-slate-800"><span className="font-medium">{s.name || 'Sans nom'}</span> <span className="text-slate-500 ml-2">{fmt(s.phone)}</span></span>
            <button onClick={() => remove(s)} className="p-1.5 rounded text-red-600 hover:bg-red-50" data-testid={`photo-sender-delete-${s.id}`}><Trash2 className="h-4 w-4" /></button>
          </li>
        ))}
      </ul>
      <form onSubmit={add} className="flex flex-wrap gap-2">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nom du vendeur" maxLength={60} className="flex-1 min-w-[140px] rounded-lg border border-slate-200 px-3 py-2 text-sm" data-testid="photo-sender-name-input" />
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="514-555-1234" required inputMode="tel" maxLength={20} className="flex-1 min-w-[140px] rounded-lg border border-slate-200 px-3 py-2 text-sm" data-testid="photo-sender-phone-input" />
        <button disabled={saving} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-60" data-testid="photo-sender-add-btn">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4" />} Autoriser
        </button>
      </form>
    </section>
  );
};
